export default __webpack_public_path__ + "static/media/TL01.25a67286.mp3";